import { COMPANY } from "./links";

export const COOKIES = {
  slug: "cookie-policy",
  title: "Cookie Policy",
  seoTitle: "Cookie Policy | Marioway Benefits Consultancy Ltd",
  description: "Which cookies and similar technologies the Marioway website uses, why, and how to manage your preferences.",
  intro: `This Cookie Policy explains how ${COMPANY.name} uses cookies and similar technologies on ${COMPANY.website}. You can accept or reject non-essential cookies using the banner shown on your first visit, and change your choice at any time through the "Cookie settings" link in the footer.`,
  summaryRo: {
    title: "Pe scurt, în română",
    items: [
      "Cookie-uri necesare (fără consimțământ): limba aleasă (RO/EN), alegerea ta privind cookie-urile și id-ul anonim al conversației din chat. Fără ele site-ul nu ar funcționa corect.",
      "Cookie-uri de statistică (opționale): PostHog ne arată ce pagini sunt vizitate ca să îmbunătățim site-ul. Se activează DOAR dacă apeși „Accept analytics”.",
      "Nu folosim cookie-uri de publicitate sau de rețele sociale.",
      "Îți poți schimba alegerea oricând din linkul „Cookie settings” din josul paginii.",
    ],
  },
  sections: [
    {
      h: "1. What cookies are",
      p: ["Cookies are small text files placed on your device by a website. Similar technologies include local storage and pixels. They allow a website to remember your actions and preferences and to understand how the site is used."],
    },
    {
      h: "2. Cookies and storage we use",
      list: [
        "Strictly necessary — mw_lang (remembers your language choice, RO/EN), mw_cookie_consent (remembers your cookie choice), mw_chat_sid (keeps your conversation with the website assistant together so you can continue it). These are needed for the website to work as you expect and do not require consent. They are stored in your browser's local storage and are not shared with third parties.",
        "Analytics (optional, consent required) — PostHog analytics cookies (for example ph_*_posthog) help us understand which pages are visited and how the website is used so that we can improve it. Analytics cookies are only set if you choose \"Accept analytics\". Data may be processed by PostHog Inc. in the United States under appropriate safeguards.",
        "Third-party content — some elements are loaded from third-party services (Google Fonts, payment-method logos from simpleicons.org, the WhatsApp QR code from qrserver.com). These providers may receive your IP address when the content loads. We do not use advertising or social-media tracking cookies.",
      ],
    },
    {
      h: "3. Managing your preferences",
      list: [
        "Use the cookie banner on your first visit to accept or reject analytics cookies.",
        "Click \"Cookie settings\" in the website footer at any time to change your choice.",
        "You can also delete or block cookies through your browser settings. Blocking strictly necessary storage may affect features such as the language selector and chat assistant.",
      ],
    },
    {
      h: "4. More information",
      p: [`For details about how we use personal information, please read our Privacy Policy. Questions: ${COMPANY.email}. Last updated: ${COMPANY.updated}.`],
    },
  ],
};
